export const EVENT_EMMITER_EVENTS = {
  FIND_RECORDS_SELECTED_CHANGED: 'FIND_RECORDS_SELECTED_CHANGED',
  INITIALIZE_SELECTED_RECORDS_MAP: 'INITIALIZE_SELECTED_RECORDS_MAP',
};
